export default function ({ $gtm, route }) {
  $gtm.init("GTM-PJZFRBZJ")
}
